import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Grid,
  Box,
  Drawer,
  List,
  styled,
  BadgeProps,
  Badge,
  Link,
  MenuItem,
  Menu,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

interface NavbarProps {
  mobileDrawerOpen?: boolean;
  onMobileDrawerClose?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ mobileDrawerOpen, onMobileDrawerClose }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const drawerOpen = mobileDrawerOpen !== undefined ? mobileDrawerOpen : isMobileDrawerOpen;

  const openMobileDrawer = () => {
    if (mobileDrawerOpen !== undefined) {
      return;
    }
    setIsMobileDrawerOpen(true);
  };

  const closeMobileDrawer = () => {
    if (onMobileDrawerClose) {
      onMobileDrawerClose();
    } else {
      setIsMobileDrawerOpen(false);
    }
  };
  const [nestedAnchorEl, setNestedAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const [currentPath, setCurrentPath] = useState<string>("");

  useEffect(() => {
    setCurrentPath(window.location.pathname);

  }, []);


  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNestedMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (nestedAnchorEl) {
      setNestedAnchorEl(null);
    } else {
      setNestedAnchorEl(event.currentTarget);
    }
  };

  const handleNestedMenuClose = () => {
    setNestedAnchorEl(null);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleMobileDrawer = () => {
    if (mobileDrawerOpen !== undefined) {
      if (onMobileDrawerClose) onMobileDrawerClose();
      return;
    }
    setIsMobileDrawerOpen(!isMobileDrawerOpen);
  };

  const handleBack = () => {
    toggleMobileDrawer();
  };
  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    "& .MuiBadge-badge": {
      // right: -3,
      // top: 20,
      // border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  }));
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        background: "transparent",
        pb: "12px",

      }}
    >
      <AppBar
        sx={{
          top: "24px",
          padding: "2px",
          bgcolor: 'transparent',
          boxShadow: 'none',
          position: 'inherit',
          width: "auto",
          right: "auto",
        }}
      >
        <Toolbar style={{ minHeight: "50px", paddingRight: "8px" }}>

          <Grid sx={{ display: { xs: "none", md: "flex" } }}>
            <nav>
              <Button
                href="/home"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "16px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Home
              </Button>
              <Button
                href="/Shop"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "16px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Shop
              </Button>
              <Button
                href="/DailyDeals"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "16px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Deals
              </Button>

              {/* <Button
                href="/Gallery"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "16px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Gallery
              </Button> */}

              <Button
                href="/NewArrivals"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "16px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Arrivals
              </Button>

              {/* <Button
                href="/"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Sweat Shirts
              </Button> */}

              {/* <Button
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  fontWeight: "300",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
                aria-controls="products-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                endIcon={<ArrowDropDownIcon />}
              >
                Shop
              </Button> */}


              {/* <Button
                href="/Gallery"
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  fontWeight: "300",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Gallery
              </Button> */}
            </nav>
          </Grid>


          <IconButton
            edge="end"
            aria-label="menu"
            onClick={openMobileDrawer}
            sx={{
              display: {
                xs: "flex",
                md: "none",
                color: "#fff",
                marginRight: "0px",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={closeMobileDrawer}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        PaperProps={{
          sx: {
            width: '100%',
          },
        }}
        sx={{
          display: { xs: "flex", md: "none" },
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent", // Set background to transparent
            backdropFilter: "blur(16px)",
          },
        }}
      >
        <Box
          sx={{
            background: "#000",
            backdropFilter: "blur(16px)",
            padding: '20px',
            height: '100vh'
          }}
        >
          {/* Header with logo and close button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography sx={{ color: "#fff" }}>
              <img src="/logo.png" alt="Logo" />
            </Typography>
            <IconButton
              onClick={closeMobileDrawer}
              sx={{
                color: "#fff",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List sx={{ paddingTop: "10px", paddingBottom: "30px", }}>
            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/home"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/home_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Home
              </Button>
            </Grid>
            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/Shop"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/shop_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Shop
              </Button>
              </Grid>
            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/DailyDeals"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/deal_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Deals
              </Button>
            </Grid>
            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/Gallery"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/gallery_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Gallery
              </Button>
            </Grid>

            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/Promotions"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",                    
                  },
                }}
              >
                <img
                  src="/icons/promotions_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Promotions
              </Button>
            </Grid>

            <Grid sx={{ borderBottom: "1px solid #202020", }}>
              <Button
                href="/NewArrivals"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  py: "20px",
                  mt: "0px",
                  "&:hover": {
                    color: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/arrivals_icon.png"
                  style={{ width: "22px", marginRight: "20px" }}
                />
                Arrivals
              </Button>
            </Grid>

            {/* <Grid>
              <Button
                href=""
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  ml: "40px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
                aria-controls="products-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                endIcon={<ArrowDropDownIcon />}
              >
                <img
                  src="/icons/billing_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />{" "}
               Shop
              </Button>

              <Menu
                id="products-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "products-menu",
                }}
                PaperProps={{ style: { borderRadius: "14px", border: "1px solid transparent",
                  background:
                    "linear-gradient(#0A0A0B, #0A0A0B) padding-box, radial-gradient(circle at top center, #fff -10%, #373737 40%) border-box",} }}
                sx={{ zIndex: "999999" }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    color: "#fff",
                    fontFamily: "Poppins",
                    fontWeight: "300",
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                >
                  <Link
                    href=""
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      display: "inherit",
                      "&:hover": {
                      color: "#fff",
                    },
                    }}
                  >
                    <img
                      src="/icons/user_icon.png"
                      style={{ height: "18px", marginRight: "6px" }}
                    />{" "}
                    Caps
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    color: "#fff",
                    fontFamily: "Poppins",
                    fontWeight: "300",
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                >
                  <Link
                    href=""
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      display: "inherit",
                      "&:hover": {
                      color: "#fff",
                    },
                    }}
                  >
                    <img
                      src="/icons/user_icon.png"
                      style={{ height: "18px", marginRight: "6px" }}
                    />{" "}
                    Sweat Shirts
                  </Link>
                </MenuItem>
              </Menu>
            </Grid> */}


          </List>
          <Box sx={{ bottom: "16px", position: "absolute",}}>
            <Typography sx={{ color: "#fff", fontSize: "14px", fontWeight: "300", marginBottom: "10px" }}>Follow us</Typography>
            <Box sx={{
              display: "flex",
              gap: "12px",
              justifyContent: "space-between",}}>
              <Link
              href=""
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              // target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href="https://api.whatsapp.com/send?phone=918856042557"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href=""
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              // target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href="https://instagram.com/TheKnockoutCulture"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ fontSize: "22px" }}
              />
            </Link>

            <Link
              href="https://www.youtube.com/channel/UCoL4PVeYZGevMmQ4mYepuSQ"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} style={{ fontSize: "22px" }} />
            </Link>
            </Box>
          </Box>
        </Box>



      </Drawer>
    </Box>
  );
};

export default Navbar;
